import type { Locale } from '@hm/contracts'
import { type Dictionary, en } from './en.ts'

export type { Dictionary, MessageKey } from './en.ts'

/**
 * English ships in the entry chunk; Nepali is fetched when somebody asks for it.
 *
 * Both together are about 8 KB gzipped over the initial-payload budget, and the
 * budget is there because the audience is on a mid-range Android over 4G. Shipping
 * a catalog nobody on this device will read is exactly the kind of thing it exists
 * to catch, so the second language is a chunk of its own.
 *
 * The trade is one extra request the first time a Nepali reader opens the app —
 * paid in parallel with the session call, and cached from then on. `en` stays
 * static because it is also the fallback when a fetch fails on a bad connection.
 */
export const CATALOGS: Record<Locale, () => Promise<Dictionary>> = {
  en: () => Promise.resolve(en),
  ne: () => import('./ne.ts').then((module) => module.ne),
}

export { en }
